<div class="w-full h-full bg-gray-50 flex flex-col relative overflow-hidden font-sans">

    <div class="absolute inset-0 z-0">
        <google-map [center]="center" [zoom]="zoom" [options]="mapOptions" height="100%" width="100%"
            class="w-full h-full">
        </google-map>
        <app-loader-google-map *ngIf="isLoading"></app-loader-google-map>
    </div>

    <div class="absolute top-0 left-0 right-0 z-20 p-4 pointer-events-none">
        <div class="bg-white/90 backdrop-blur-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-3xl p-1 pointer-events-auto transition-all duration-300 ease-out border border-white/50"
            [ngClass]="isCustomForm ? 'animation-display-custom' : 'rounded-full'">

            <div class="flex flex-col">

                <div class="flex items-center w-full relative">

                    <div class="flex-1 flex items-center px-4 h-12 transition-all duration-300"
                        [ngClass]="isCustomForm ? 'w-0 opacity-0 overflow-hidden p-0' : 'w-full opacity-100'">

                        <svg class="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                        <input
                            class="bg-transparent border-none text-gray-700 font-medium text-base w-full focus:outline-none placeholder-gray-400 h-full"
                            type="text" readonly (click)="isSearchOpen = !isSearchOpen"
                            [value]="textSearch ? textSearch : (currentLanguage === 'TH' ? 'ค้นหาสถานที่ชาร์จ...' : 'Find charging station...')">
                        <button *ngIf="textSearch" (click)="clearSearchParking(); $event.stopPropagation()"
                            class="ml-2 w-6 h-6 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center hover:bg-red-100 hover:text-red-500 transition-colors">
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <div class="absolute left-0 right-12 text-center transition-all duration-300"
                        [ngClass]="isCustomForm ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'">
                        <span class="font-bold text-gray-800">{{ currentLanguage === 'TH'
                            ? 'ตัวเลือกการค้นหา'
                            : 'Filter Options' }}</span>
                    </div>

                    <div class="pr-2 pl-2 border-l border-gray-100" [ngClass]="{'border-none': isCustomForm}">
                        <button (click)="toggleCustomForm()"
                            class="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200"
                            [ngClass]="isCustomForm ? 'bg-gray-100 text-gray-600 rotate-90' : 'bg-yellow-400 text-white shadow-md shadow-yellow-200 hover:bg-yellow-500'">
                            <svg *ngIf="!isCustomForm" class="w-5 h-5" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4">
                                </path>
                            </svg>
                            <svg *ngIf="isCustomForm" class="w-5 h-5" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.25,1,0.5,1)]"
                    [ngClass]="isCustomForm ? 'max-h-[300px] opacity-100 mt-2 pb-2' : 'max-h-0 opacity-0'">

                    <div class="px-4 pt-2 pb-4 space-y-5">

                        <div class="bg-gray-100/80 p-1.5 rounded-xl flex relative">
                            <div class="absolute inset-y-1.5 transition-all duration-300 ease-out bg-white rounded-lg shadow-sm border border-gray-200"
                                [ngStyle]="{'width': '50%', 'left': nearbyFormLocation === 1 ? '0.375rem' : '50%'}">
                            </div>

                            <button (click)="clickNearbyForm(1)"
                                class="relative z-10 flex-1 py-2 text-sm font-bold text-center transition-colors duration-300"
                                [disabled]="isCustomRadius" [class.opacity-50]="isCustomRadius"
                                [ngClass]="nearbyFormLocation === 1 ? 'text-gray-800' : 'text-gray-500'">
                                {{ currentLanguage === "TH" ? "ทั้งหมด" : "All" }}
                            </button>
                            <button (click)="clickNearbyForm(2)"
                                class="relative z-10 flex-1 py-2 text-sm font-bold text-center transition-colors duration-300"
                                [disabled]="isCustomRadius" [class.opacity-50]="isCustomRadius"
                                [ngClass]="nearbyFormLocation === 2 ? 'text-gray-800' : 'text-gray-500'">
                                {{ currentLanguage === "TH" ? "ใกล้ฉัน (10 km)" : "Nearby (10 km)" }}
                            </button>
                        </div>
                        <div>
                            <label class="inline-flex items-center cursor-pointer">
                                <input type="checkbox" id="customRadiusCheckbox" [(ngModel)]="isCustomRadius"
                                    (change)="clickFormCustom()" class="sr-only peer">

                                <div class="relative w-10 h-5 bg-gray-200 
                                    peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-yellow-100 rounded-full peer 
                                    peer-checked:after:translate-x-5 rtl:peer-checked:after:-translate-x-5 peer-checked:after:border-white 
                                    after:content-[''] 
                                    after:absolute 
                                    after:top-[2px] 
                                    after:start-[2px] 
                                    after:bg-white 
                                    after:border-gray-300 
                                    after:border 
                                    after:rounded-full 
                                    after:h-4 
                                    after:w-4 
                                    after:transition-all peer-checked:bg-yellow-600">
                                </div>
                                <span class="ms-3 text-sm font-medium text-gray-700 select-none">
                                    {{ currentLanguage === 'TH' ? 'ระบุระยะทางเอง' : 'Custom Radius' }}
                                </span>
                            </label>
                            <div class="space-y-3" *ngIf="isCustomRadius">
                                <div class="flex justify-between items-center px-1">
                                    <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">{{
                                        currentLanguage === 'TH' ? 'ระยะทาง' : 'Radius' }}</span>
                                    <div class="flex items-baseline text-yellow-500">
                                        <span class="text-xl font-bold">{{ selectedRadius }}</span>
                                        <span class="text-xs font-medium ml-1">km</span>
                                    </div>
                                </div>
                                <input id="radiusSlider" type="range" min="1" max="100" step="1"
                                    [(ngModel)]="selectedRadius" (change)="onRadiusChange()"
                                    class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-yellow-400 hover:accent-yellow-500 transition-all">
                            </div>
                        </div>

                        <div class="pt-2 border-t border-gray-100">
                            <button (click)="clickFilterForm(1)"
                                class="w-full flex items-center justify-between px-4 py-3 rounded-xl border   shadow-sm shadow-gray-200 transition-all group"
                                [ngClass]="filterForm  == 1 ? 'bg-yellow-400/60 border-yellow-100' : 'bg-white border-gray-200'">
                                <div class="flex items-center space-x-3">
                                    <div class="w-8 h-8 rounded-full flex items-center justify-center transition-colors"
                                        [ngClass]="filterForm == 1 ? 'bg-yellow-100  text-yellow-700' : 'bg-gray-100 text-gray-700'">
                                        <img src="icons/mobile_charge_orange_dark.svg" />
                                        <!-- <img src="data:image/png;base64,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"
                                            alt="car" class="w-5 h-5 opacity-70"> -->
                                    </div>
                                    <span class="text-sm font-bold "
                                        [ngClass]="filterForm == 1 ? 'text-yellow-700' : 'text-gray-700'">EV
                                        Charger</span>
                                </div>
                                <div class="flex items-center ">
                                    <!-- <span
                                        class="text-xs font-semibold px-2 py-1 rounded bg-yellow-100 text-yellow-600 mr-2"
                                        *ngIf="filterForm == 1">{{ currentLanguage == 'TH' ? 'เลือก' : 'In Use'
                                        }}</span> -->
                                    <div class="w-5 h-5 rounded-full border-2  flex items-center justify-center bg-white"
                                        [ngClass]="{
                                            'bg-yellow-600 border-yellow-600' : filterForm == 1,
                                            'bg-gray-100 border-gray-200' : filterForm != 1
                                        }">
                                        <svg class="w-3 h-3 text-white" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                                d="M5 13l4 4L19 7"></path>
                                        </svg>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="absolute right-4 top-24 flex flex-col items-end space-y-3 z-10 pointer-events-none">
        <div class="flex flex-col items-end space-y-2 pointer-events-auto">
            <div *ngIf="showLegendModal"
                class="bg-white/95 backdrop-blur rounded-2xl shadow-xl border border-gray-100 p-4 w-40 animate-fade-in-up origin-bottom-right">
                <h4 class="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-3">Status</h4>
                <div class="space-y-2.5">
                    <div class="flex items-center text-xs font-medium text-gray-600">
                        <span class="w-2.5 h-2.5 rounded-full bg-green-500 mr-2.5 ring-2 ring-green-100"></span>
                        {{ currentLanguage === "TH" ? "ว่าง" : "Available"}}
                    </div>
                    <div class="flex items-center text-xs font-medium text-gray-600">
                        <span class="w-2.5 h-2.5 rounded-full bg-yellow-400 mr-2.5 ring-2 ring-yellow-100"></span>
                        {{ currentLanguage === "TH" ? "เหลือน้อย" : "Limited"}}
                    </div>
                    <div class="flex items-center text-xs font-medium text-gray-600">
                        <span class="w-2.5 h-2.5 rounded-full bg-red-500 mr-2.5 ring-2 ring-red-100"></span>
                        {{ currentLanguage === "TH" ? "เต็ม" : "Full"}}
                    </div>
                </div>
            </div>
            <button (click)="toggleLegend()"
                class="w-12 h-12 bg-white hover:bg-gray-50 rounded-full shadow-lg flex items-center justify-center text-gray-500 hover:text-yellow-500 transition-all active:scale-95 border border-gray-100">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </button>
        </div>
    </div>

    <div class="absolute right-4 bottom-24 flex flex-col items-end space-y-3 z-10 pointer-events-none">



        <div class="flex flex-col items-center space-y-2 pointer-events-auto">
            <div *ngIf="menuOpen" class="flex flex-col space-y-2 animate-slide-up origin-bottom pb-2">
                <button
                    *ngFor="let color of [{idx:0, code:'#f91c1c', label:'R'}, {idx:1, code:'#ffd047', label:'Y'}, {idx:2, code:'#29d543', label:'G'}]"
                    (click)="selectColor(color.idx, color.code)"
                    class="w-10 h-10 rounded-full shadow-md flex items-center justify-center transition-all hover:scale-110 font-bold text-xs"
                    [ngClass]="activeIndex === color.idx ? 'ring-2 ring-offset-2 ring-gray-300 scale-110 text-white' : 'text-white'"
                    [style.backgroundColor]="color.code">
                    {{color.label}}
                </button>
            </div>
            <button (click)="toggleMenu()"
                class="w-12 h-12 bg-white hover:bg-gray-50 rounded-full shadow-lg flex items-center justify-center text-gray-700 hover:text-yellow-500 transition-all active:scale-95 border border-gray-100">
                <span class="text-xl font-light">{{ menuOpen ? '✕' : '☰' }}</span>
            </button>
        </div>

        <button (click)="clickCenter()"
            class="pointer-events-auto w-12 h-12 bg-yellow-400 hover:bg-yellow-500 rounded-full shadow-lg shadow-yellow-200 flex items-center justify-center text-white transition-all active:scale-95 active:-rotate-12">

            <svg class="w-6 h-6 ml-0.5 mt-0.5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L4.5 20.29a.5.5 0 0 0 .79.54L12 17.25l6.71 3.58a.5.5 0 0 0 .79-.54L12 2z"></path>
            </svg>

        </button>
    </div>


    <app-modal-google-map *ngIf="showModal" [siteId]="selectSiteId" [name]="selectName" [position]="selectPosition"
        [available]="selectedAvailable" [distance]="selectedDistance" [price]="selectedPrice"
        [publicRef]="selectPublicRef" (closed)="showModal = false">
    </app-modal-google-map>

    <div class="fixed inset-0 z-50 flex flex-col bg-gray-50 animate-fade-in" *ngIf="isSearchOpen">

        <div class="bg-white px-4 py-4 flex flex-col shadow-sm z-10 space-y-3">
            <div class="flex items-center w-full">
                <button (click)="isSearchOpen = false"
                    class="mr-3 w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors flex-shrink-0">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                        </path>
                    </svg>
                </button>
                <div class="flex-1 bg-gray-100 rounded-xl flex items-center px-4 h-12">
                    <svg class="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                    <input
                        class="bg-transparent w-full h-full border-none focus:outline-none text-gray-800 placeholder-gray-400"
                        type="text" [placeholder]="currentLanguage === 'TH' ? 'ค้นหาสถานที่...' : 'Search places...'"
                        [(ngModel)]="textSearch" (input)="searchParkingLocations()" autofocus />
                    <button *ngIf="textSearch" (click)="textSearch=''; searchParkingLocations()"
                        class="ml-2 text-gray-400 hover:text-gray-600">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Filter Options -->
            <div class="flex items-center pl-14">
                <label class="inline-flex items-center cursor-pointer group">
                    <div class="relative">
                        <input type="checkbox" [(ngModel)]="isSearchEvChargerOnly" (change)="searchParkingLocations()"
                            class="sr-only peer">
                        <div
                            class="w-10 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-400">
                        </div>
                    </div>
                    <span class="ml-3 text-sm font-medium text-gray-600 group-hover:text-gray-800 transition-colors">
                        {{ currentLanguage === 'TH' ? 'แสดงเฉพาะ EV Charger' : 'Show only EV Charger' }}
                    </span>
                </label>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto p-4 space-y-3">
            <div *ngIf="filteredParking === null"
                class="flex flex-col items-center justify-center h-64 text-gray-400 animate-fade-in-up">
                <div class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                    <svg class="w-10 h-10 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                    </svg>
                </div>
                <p class="font-medium">{{ currentLanguage === "TH" ? "ไม่พบสถานที่" : "No results found" }}</p>
            </div>

            <ng-container *ngIf="filteredParking !== null">
                <div *ngFor="let marker of filteredParking.length > 0 ? filteredParking : markerPositions"
                    (click)="selectSearchParking(marker)"
                    class="bg-white p-3 rounded-2xl shadow-sm border border-gray-100 flex items-center gap-4 active:scale-[0.98] transition-all duration-200 cursor-pointer hover:shadow-md animate-fade-in-up">

                    <div
                        class="w-16 h-16 rounded-xl bg-gradient-to-br from-yellow-50 to-yellow-100 flex items-center justify-center flex-shrink-0 text-yellow-500">
                        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>

                    <div class="flex-1 min-w-0">
                        <h3 class="font-bold text-gray-800 text-sm truncate mb-1">{{ marker.name }}</h3>
                        <div class="flex items-center text-xs text-gray-500 mb-1">
                            <svg class="w-3.5 h-3.5 mr-1 text-gray-400" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                                </path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>
                            <span>{{ marker.distance }} km</span>
                        </div>
                        <div class="flex items-center">
                            <span class="w-2 h-2 rounded-full mr-2"
                                [ngClass]="marker.available > 0 ? 'bg-green-500' : 'bg-red-500'"></span>
                            <span class="text-xs font-medium"
                                [ngClass]="marker.available > 0 ? 'text-green-600' : 'text-red-500'">
                                {{ marker.available | number:'1.0-0' }} {{ currentLanguage === "TH" ? "ว่าง" :
                                "Available" }}
                            </span>
                        </div>
                        <app-site-amenities *ngIf="marker.amenityCodes?.length" class="mt-1.5"
                            [codes]="marker.amenityCodes ?? null" [lang]="currentLanguage" variant="icons"
                            [max]="5"></app-site-amenities>
                    </div>

                    <div class="text-gray-300">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7">
                            </path>
                        </svg>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</div>